//@ts-ignore -> needed for zero installs, unfortunately, project isn't ready for that
import { all } from 'redux-saga/effects';

import authSaga from './auth/saga';

export default function* rootSaga() {
  yield all([authSaga()]);
}
